/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PromotionOfferType;

(function (PromotionOfferType) {
  PromotionOfferType["MONETARY"] = "monetary";
  PromotionOfferType["PERCENTAGE"] = "percentage";
})(PromotionOfferType || (PromotionOfferType = {}));